import * as service from '../agent/routers/cliJsCode/service';
import { NpmPackageError, TimeoutError } from '../errors';
import type { WebDriver } from '../player/webdriver';
import type { LauncherDriverType } from '../player/chromeLauncherTestPlayer';
import type { SerializableRemoteObject } from 'clickim/src/background/stepActions/remoteStepActionMixin';

export const run = async (browser: WebDriver | LauncherDriverType, step: SerializableRemoteObject) => {
    const { stepId, testResultId, retryIndex, stepResultId, packageData, timeout } = step.data;
    try {
        const data = await service.installPackage(stepId, testResultId, retryIndex, packageData, stepResultId, timeout);
        return { data, success: true };
    } catch (err) {
        if (err instanceof NpmPackageError) {
            return {
                success: false,
                code: 'invalid-node-package',
                message: err.message,
            };
        }
        if (err instanceof TimeoutError) {
            return {
                success: false,
                code: 'timeout',
            };
        }
        throw err;
    }
};
